/* eslint-disable jsx-a11y/alt-text */
import { Video } from "lucide-react";
import video1 from "../../assets/images/video_2.png";
import video2 from "../../assets/images/video_3.png";
import video3 from "../../assets/images/video_4.png";

const reels = [
  {
    id: 2,
    title: "When She Starts to Sing!",
    channel: "Guitaro",
    views: "544,1K lượt xem",
    time: "a day ago",
    duration: "5:00",
    image: video1,
  },
  {
    id: 3,
    title: "Security Guard Stuns Crowd with Jamaican Freestyle",
    channel: "Guitaro",
    views: "239,7K lượt xem",
    time: "5 days ago",
    duration: "6:16",
    image: video2,
  },
  {
    id: 4,
    title: "Look at the crowd that forms!",
    channel: "Guitaro",
    views: "187,7K lượt xem",
    time: "30 March at 22:46",
    duration: "5:32",
    image: video3,
  },
];

export const RelatedReels = () => (
  <div className="bg-white p-4 rounded-xl shadow-sm">
    <h3 className="font-semibold text-lg mb-3 flex items-center gap-2">
      <Video className="w-5 h-5" /> Related Videos
    </h3>
    <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(270px,1fr))]">
      {reels.map((item) => (
        <div key={item.id}>
          <div className="relative rounded-lg overflow-hidden bg-black aspect-video mb-2">
            <img src={item.image} className="w-full h-full object-cover" />
            <span className="absolute bottom-1 right-1 text-xs text-white bg-black bg-opacity-70 px-1 rounded">
              {item.duration}
            </span>
          </div>
          <div className="text-sm font-medium line-clamp-2">{item.title}</div>
          <div className="text-xs text-gray-500">
            {item.channel}
            <br />
            {item.views} · {item.time}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default RelatedReels;
